import { orderHistoryTableStyles as styles } from "@iewccouk/Overrides/Widgets/OrderHistory/OrderHistoryTable";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    css: css`
        overflow: auto;
        & .orders-view__actions-btn {
            appearance: none !important;
        }
    `,
};

styles.actionSelector = {
    mergeCss: true,
    iconProps: {
        css: css`
            display: none;
        `,
    },
    css: css`
        &&&& {
            appearance: none;
            background-color: transparent;
            background-image: url("/Themes/IEWCTheme/Images/svg-sprites/three-dots.svg");
            background-position: center;
            background-repeat: no-repeat;
            border: none;
            line-height: 30px;
            margin: 0;
            width: 50px;
            padding: 0;
            text-indent: 1px;
        }
    `,
    cssOverrides: {
        formInputWrapper: css`
            text-align: center;
        `,
    },
};
